import React, { useState, useEffect, useRef } from 'react';

export type UseModal = (
  containingRefs?: React.Ref<HTMLElement>[],
  noOverlay?: boolean
) => [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
  React.RefObject<HTMLDivElement | null>
];

const useModal: UseModal = (containingRefs = [], noOverlay = false) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!noOverlay) {
      const close = (e: MouseEvent) => {
        const refs = [...containingRefs, modalRef];
        if (
          refs.every(ref => typeof ref !== 'function' && !ref?.current?.contains(<Node>e.target))
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) window.addEventListener('click', close);
      else window.removeEventListener('click', close);
      return () => window.removeEventListener('click', close);
    }
    return () => {};
  }, [isOpen]);

  return [isOpen, setIsOpen, modalRef];
};

export default useModal;
